<template>
  <div class="" style="padding:.2rem 0 8rem 0">

    <div class="order-success">
      <div class="icon"></div>
      <div class="title">报名成功</div>
      <div class="desc">
      </div>
    </div>
    <div class="order-success">
      <img :src="row.erweiimg[0].url" v-if="row.erweiimg.length>0"/>
      <p v-if="row.erweiimg.length>0">扫码加工作人员好友，进入培训微信群</p>
    </div>
    <van-divider>场次信息</van-divider>
    <van-cell-group>

      <van-cell
          input-align="right"
          title="单位"
          :value="row.danwei"
      />
      <van-cell
          input-align="right"
          title="场次"
          :value="row.station_name"
      />
      <van-cell
          input-align="right"
          title="时间"
          :value="row.station.startdate+'至'+row.station.enddate"
      />


    </van-cell-group>
    <van-divider>个人信息</van-divider>
    <van-cell-group>
      <van-cell
          input-align="right"
          title="省市区"
          :value="row.province+'  '+row.city+' '+row.county+' '+row.address"
      />
      <van-cell
          input-align="right"
          title="姓名"
          :value="row.member.name"
      />
      <van-cell
          input-align="right"
          title="身份证号"
          :value="row.member.num"
      />
      <van-cell
          input-align="right"
          title="手机号"
          :value="row.member.phone"
      />
    </van-cell-group>

    <div class="cert-li" v-if="row.cert_url && row.cert_url.url">
      <van-divider>结业证书</van-divider>
      <img :src="row.cert_url.url" alt="">
      <div class="cert-button">
        <van-button v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存
        </van-button>
        <van-button v-else @click="appDownload(row.cert_url.filename,row.cert_url.url)"
                    style="margin: 10px auto; text-align: center " type="default" round>点击下载
        </van-button>
      </div>
    </div>
    <van-divider>资料信息</van-divider>
    <van-cell
        v-for="(goods,index) in row.goods_list"
        :key="inedx"
        input-align="right"
        :title="goods.item_title"
        :value="goods.count+''+goods.unit +' '"
        :label="goods.total_price+'元'"
    />

    <div style="margin-top: 10px; text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" v-if="row.next_gjsb" round v-rblink="{name:'SongpeiApplyFormStep3' ,query:{ id:row.id }}">资质申报
      </van-button>
    </div>

    <div style="margin-top: 10px; text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" round @click="toStep2">资料订购
      </van-button>
    </div>

    <div style="margin-top: 10px; text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" v-if="row.station.can_exame==1" round v-rblink="{name:'SongpeiExame' ,query:{ id:row.id }}">在线考试
      </van-button>
    </div>
    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round v-rblink="{name:'SongpeiApplyList'}">我的报名记录
      </van-button>
    </div>

    <van-action-sheet
        v-model="ltShow"
        :actions="ltActions"
        cancel-text="取消"
        @select="onLtSelect"
        close-on-click-action
        @cancel="ltShow=false"
    />

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success .desc {
  padding: 10px;
  text-align: left;
}

.order-success .desc p {
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order-success img {
  width: 90%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success p {
  font-size: 12px;
  color: #999;
}

.cert-li {
  margin:0 .3rem;
  text-align: center;
}

.cert-li img {
  width: 100%;
  border-radius: 5px;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      ltShow: false,
      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],
      validator,
      saveLoading: false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      formData: {
        id: 0
      },
      isApp: window.isApp(),
      row: {
        member: {},
        erweiimg: [],
        station: {},
        goods_list: []
      }
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    document.title = "申请成功"
    that.formData.id = this.$route.query.id;
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    appDownload(name, url){
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name+'.jpg',
          url:url,
        }
      });
    },
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          let name = that.ltImgSrc.split('?')[0].split('/').pop();
          console.log(that.ltImgSrc, name);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': name,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    fetch() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      that.$api.post('/api/songpei/successdetail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
        Toast.clear()
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    toStep2() {
      rbLink({name: 'SongpeiApplyFormStep2', query: {id: this.row.id}})
    }

  }
}
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormSuccess.vue?1a6c4456